import ViewAttribute from './ViewAttribute'

export default ViewAttribute
